<div class="paginator">
  <p-paginator #pPaginator
               [rows]="rows"
               [totalRecords]="totalRecords"
               [rowsPerPageOptions]="rowsPerPageOptions"
               (onPageChange)="onPageChange($event)"
  ></p-paginator>
</div>
